import type { FormError } from './types'

export default function collateErrors(_values, props, json): FormError {
    const { messages } = props

    if (json && json.errors) {
        const errors: FormError = {}
        json.errors.forEach(({ errorKey }) => {
            switch (errorKey) {
                default:
                    errors._error = messages.errors.generic()
            }
        })
        return errors
    }
    return { _error: messages.errors.global() }
}

